import {
    Box,
    Typography,
    Grid,
    Divider,
} from '@mui/material'
import ShareIcon from '../../../assets/app/personal-loan/icon_share.png'
import DownLoadIcon from '../../../assets/app/personal-loan/icon_download.png'
import BG from '../../../assets/app/personal-loan/requirements_bg.png'
import { Image } from 'antd'
import { ROOT_PATH } from '../../../common/config'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMRequirements: React.FC = () => {

    const { t } = useTranslation()

    // 打开新页面
    const openNewPage = (index: number) => {
        window.open(ROOT_PATH + (index === 1 ? '/repayment-channel' : 'product-disclosure'))
    }
        
    const data1 = [
        {
            'title': t('t183'),
            'data': [
                t('t184'),
                t('t185'),
                t('t186'),
            ],
        },
        {
            'title': t('t187'),
            'data': [
                t('t188'),
                t('t189'),
            ],
        },
    ]

    const data2 = [
        {
            'title': t('t190'),
            'data': [t('t191'),
                t('t192'),
                t('t193'),
            ],
        },
        {
            'title': t('t194'),
            'data': [t('t195'),
                t('t196'),
                t('t197')
            ],
        },
    ]

    const data3 = [
        {
            'title': t('t198'),
            'content': t('t199'),
            'icon': DownLoadIcon
        },
        {
            'title': t('t200'),
            'content': t('t201'),
            'icon': ShareIcon
        },
    ]

    const renderItem1 = (index: number) => {
        return (
            <Grid key={index} item xs={6}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                }}>
                    <Typography fontSize={16} fontWeight={700} color={'#141F39'}>
                        {data1[index]['title']}
                    </Typography>

                    <Box sx={{ paddingTop: '0px' }}>
                        {data1[index]['data'].map((subItem, subIndex) => (
                            renderTitleItem(subItem, subIndex)
                        ))}
                    </Box>
                </Box>
            </Grid>
        )
    }

    const renderItem2 = (index: number) => {
        return (
            <Grid key={index} item xs={6}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                }}>
                    <Typography fontSize={16} fontWeight={700} color={'#141F39'}>
                        {data2[index]['title']}
                    </Typography>

                    <Box sx={{ paddingTop: '0px' }}>
                        {data2[index]['data'].map((subItem, subIndex) => (
                            renderTitleItem(subItem, subIndex)
                        ))}
                    </Box>
                </Box>
            </Grid>
        )
    }

    const renderTitleItem = (item: string, index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '4px',
            }}>
                <Box sx={{
                    paddingTop: '7px',
                }}>
                    <Box sx={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '3px',
                        backgroundColor: '#6B6B6B'
                    }}></Box>
                </Box>
                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'8px'}>
                    {item}
                </Typography>
            </Box>
        )
    }

    const renderItem3 = (index: number) => {
        return (
            <Grid item key={index} xs={6}>
                <Box>
                    <Typography fontSize={16} fontWeight={700} color={'#141F39'}>
                        {data3[index]['title']}
                    </Typography>
                    <Box onClick={()=>{openNewPage(index)}} sx={{
                        paddingTop: '6px',
                        display: 'flex',
                        flexDirection: 'row',
                        cursor: 'pointer'
                    }}>
                        <Image src={data3[index]['icon']} width={24} height={24} alt='' preview={false}></Image>
                        <Box sx={{ flex: '1', paddingLeft: '8px' }}>
                            <Typography fontSize={16} fontWeight={700} color={'#6B6B6B'}>
                                {data3[index]['content']}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingTop: '60px',
                paddingBottom: '60px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
            }}
        >

            <Box sx={{ flex: '1', paddingRight: isTablet ? '20px' : '48px'}}>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'}>
                    {t('t182')}
                </Typography>

                <Grid container rowSpacing={3} columnSpacing={2} paddingTop={'24px'}>
                    {data1.map((item, index) => (renderItem1(index)))}
                </Grid>

                <Box sx={{
                    paddingTop: '24px',
                    paddingBottom: '24px',
                    paddingLeft: '2px',
                }}>
                    <Divider sx={{ background: 'rgba(57, 33, 245, 0.15)' }} />
                </Box>

                <Grid container rowSpacing={3} columnSpacing={2}>
                    {data2.map((item, index) => (renderItem2(index)))}
                </Grid>

                <Box sx={{paddingTop: '40px'}}>
                    <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'}>
                        {t('t202')}
                    </Typography>
                </Box>
                
                <Box sx={{
                    paddingTop: '24px',
                    paddingBottom: '24px',
                    paddingLeft: '2px',
                }}>
                    <Divider sx={{ background: 'rgba(57, 33, 245, 0.15)' }} />
                </Box>

                <Grid container columnSpacing={2}>
                    {data3.map((item, index) => (
                        renderItem3(index)
                    ))}
                </Grid>

            </Box>

            <Image src={BG} width={isTablet ? 460 : 636} height={isTablet ? 474 : 655} alt='' preview={false}></Image>
        </Box >
    )
}

// ======================= EXPORT
export default SMRequirements
